/**
 * @author        matt@zumper.com (Matthieu Devlin)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   Constants to be used for Actions in shared components
 */

/* NOTIFICATION SETTINGS */
export const GET_NOTIFICATION_SETTINGS = 'GET_NOTIFICATION_SETTINGS'
export const RESET_NOTIFICATION_START_DATE = 'RESET_NOTIFICATION_START_DATE'
export const SAVE_NOTIFICATION_SETTINGS = 'SAVE_NOTIFICATION_SETTINGS'
export const SAVE_NOTIFICATION_SETTINGS_ERROR = 'SAVE_NOTIFICATION_SETTINGS_ERROR'
export const SAVE_NOTIFICATION_SETTINGS_SUCCESS = 'SAVE_NOTIFICATION_SETTINGS_SUCCESS'
export const SNOOZE_NOTIFICATIONS = 'SNOOZE_NOTIFICATIONS'
export const TOGGLE_NOTIFICATIONS = 'TOGGLE_NOTIFICATIONS'
export const UPDATE_NOTIFICATION_SETTING = 'UPDATE_NOTIFICATION_SETTING'
